import React from 'react';
import './blog.css'; // Adjusted path assuming CSS is in the same directory as this component
import { a } from 'react-router-dom';
import blog1 from '../../../img/blog-home-2.jpeg';
import blog2 from '../../../img/blog-home-new.jpeg';
import blog3 from '../../../img/blog-new.jpeg';
import blog4 from '../../../img/blog-main2.jpeg';
import blog5 from '../../../img/blog-main-1.jpeg';
import blog6 from '../../../img/blog-main.jpeg';


const Blog = () => {
  return (
    <div className="container blog-margin py-5">
      {/* Header */}
      <div className="contact-header fade-in-top">
        <h1>Our Exclusive Blogs</h1>
      </div>

      {/* Blog Section */}
      <div className="container mt-5">
        <div className="row g-4">
          {/* Blog Card 1 */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="0">
                    <a href="/blog" className="text-decoration-none">
                    <div className="blog-card-blogs">
                      {/* <!-- Badges --> */}
                      <div className="blog-badges">
                        <button className="blog-badge"><i className="fa-solid fa-star"></i>FEATURED</button>
                        <button className="blog-badge"><i className="fa-solid fa-calendar"></i>FEB 7, 2024</button>
                        <button className="blog-badge"><i className="fa-solid fa-clipboard"></i>NEWS</button>
                      </div>
                      {/* <!-- Image --> */}
                      <img src={blog1} alt="Blog about technology and trends" />
          
                    </div>
                    {/* <!-- Content --> */}
                    <div className="blog-content">
                      <p>"The Future of IT Services: Trends to Watch in 2024"</p>
                    </div>
                    </a>
                  </div>

          {/* Blog Card 2 */}
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
          <a href=".blog" className="text-decoration-none">
            <div className="blog-card-blogs">
              <div className="blog-badges">
                <button className="blog-badge"><i className="fa-solid fa-calendar"></i>FEB 7, 2024</button>
                <button className="blog-badge"><i className="fa-solid fa-clipboard"></i>Article</button>
              </div>
              <img src={blog2} alt="Navigating the Marketplace for SEO" />
            </div>
            <div className="blog-content">
              <p>"Navigating the Marketplace for SEO: Finding the Right Solutions for Your Business"</p>
            </div>
            </a>
          </div>

          {/* Blog Card 3 */}
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
          <a href=".blog" className="text-decoration-none">
            <div className="blog-card-blogs">
              <div className="blog-badges">
                <button className="blog-badge"><i className="fa-solid fa-calendar"></i>FEB 7, 2024</button>
                <button className="blog-badge"><i className="fa-solid fa-clipboard"></i>NEWS</button>
              </div>
              <img src={blog3} alt="SEO Tools Guide" />
            </div>
            <div className="blog-content">
              <p>"Empower Your SEO Strategy with Top SEO Tools: A Comprehensive Guide"</p>
            </div>
            </a>
          </div>

          {/* Blog Card 4 */}
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
          <a href=".blog" className="text-decoration-none">
            <div className="blog-card-blogs">
              <div className="blog-badges">
                <button className="blog-badge"><i className="fa-solid fa-star"></i>FEATURED</button>
                <button className="blog-badge"><i className="fa-solid fa-calendar"></i>FEB 7, 2024</button>
                <button className="blog-badge"><i className="fa-solid fa-clipboard"></i>TIPS</button>
              </div>
              <img src={blog4} alt="Power of Organic Search" />
            </div>
            <div className="blog-content">
              <p>"Unveiling the Power of Organic Search: Why It Matters and How to Leverage It"</p>
            </div>
            </a>
          </div>

          {/* Blog Card 5 */}
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
          <a href=".blog" className="text-decoration-none">
            <div className="blog-card-blogs">
              <div className="blog-badges">
                <button className="blog-badge"><i className="fa-solid fa-calendar"></i>FEB 7, 2024</button>
                <button className="blog-badge"><i className="fa-solid fa-clipboard"></i>NEWS</button>
              </div>
              <img src={blog5} alt="Guide to Ranking on Google" />
            </div>
            <div className="blog-content">
              <p>"Unlocking the Secret Sauce: A Guide to Ranking on Google"</p>
            </div>
            </a>
          </div>

          {/* Blog Card 6 */}
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
          <a href=".blog" className="text-decoration-none">
            <div className="blog-card-blogs">
              <div className="blog-badges">
                <button className="blog-badge"><i className="fa-solid fa-star"></i>FEATURED</button>
                <button className="blog-badge"><i className="fa-solid fa-calendar"></i>MAR 1, 2024</button>
                <button className="blog-badge"><i className="fa-solid fa-clipboard"></i>TIPS</button>
              </div>
              <img src={blog6} alt="SEO Performance Guide" />
            </div>
            <div className="blog-content">
              <p>"The Ultimate Guide to Boosting Your Website's SEO Performance"</p>
            </div>
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Blog;
